
import React from "react";
import { useContext } from "react";
import { Controller, useWatch } from "react-hook-form";
import { BoxFull, Dropdown, InputTextarea, Calendar } from "iuvity-ui-components";
import { AppContext } from "../../context/index";
import { PhoneNumberInput } from "iuvity-ui-components/dist/phonenumberinput"
import { CustomInput } from "../inputs/CustomInput";
import { MultiSelect } from "primereact/multiselect";
import { RadioButton } from "iuvity-ui-components/dist/radiobutton";
import { FieldsLinkedTocreateLabelsButton } from "../../constants";

interface CustomFormComponentProps {
    functionality: string;
    fields: any;
    disabledFieldsObject?: any;
    isOptional?: any;
    form: any;
    dropdownOptions?: any;
    radioButtonOptions?: any;
    boxTitle?: string;
    schemaOfValidation: (t: Function) => {};
    language?: string;
    calendarTranslations?: any;
    calendarOptions?: any;
    setCalendarOptions?: Function;
    REVALIDATE_FORM_PROPS?: any;
    readOnlyObject?: any;
    properties?: boolean;
    isDetail?: boolean;
    dropdownFilterObject?: any;
    customComponent?: React.ReactNode
    tooltipTextObject?: any;
    dropdownShowClearObject?: any;
}

export const CustomFormComponent: React.FC<CustomFormComponentProps> = ({
    functionality,
    fields,
    disabledFieldsObject,
    form,
    dropdownOptions = [],
    radioButtonOptions = {},
    boxTitle,
    isOptional,
    schemaOfValidation,
    language = 'en',
    calendarTranslations = {},
    calendarOptions,
    setCalendarOptions,
    REVALIDATE_FORM_PROPS,
    readOnlyObject,
    properties,
    isDetail = false,
    dropdownFilterObject,
    customComponent,
    tooltipTextObject,
    dropdownShowClearObject
}) => {
    const {
        t,
    } = useContext(AppContext);

    const {
        control,
        getValues,
        setValue,
        formState: { errors },
    } = form;

    const startDate = getValues().hasOwnProperty('startDate') ? 'startDate' : 'expeditionDate';

    const typeValue = useWatch({
        control,
        name: "type",
    });

    const isforallValue = useWatch({
        control,
        name: "isdefaultforall",
    });

    const mainEmailValue = useWatch({
        control,
        name: "mainEmail",
    });

    const RenderForm = (newKey: any, property: any) => {
        return (
            <div
                key={`c-${property.key}`}
                className="mb-4"
            >
                <Controller
                    key={newKey}
                    name={newKey}
                    control={control}
                    rules={(schemaOfValidation(t) as any)[newKey === 'usagelist' && isforallValue === true ? "usagelistv2" : newKey]}
                    render={({ field }) => {
                        let extraProps = {
                            keyfilter:
                                property.key === "defaultvalue" && typeValue === "number"
                                    ? /^[0-9]/
                                    : (schemaOfValidation(t) as any)[newKey]?.keyfilter,
                            maxLength: (schemaOfValidation(t) as any)[newKey]?.maxLength?.value,
                        };
                        // Uso del field.onChange solo en Calendar porque no es reactivo en campos dependientes
                        if (property.type === 'calendar') {
                            field.onChange = (e) => {
                                document.getElementsByClassName('p-timepicker')[0].classList.remove('p-disabled');
                                setValue(
                                    field.name,
                                    property.type === 'phone' ? e : e.target.value,
                                    REVALIDATE_FORM_PROPS
                                );
                                if (setCalendarOptions && (newKey === 'startDate' || newKey === 'expeditionDate')) {
                                    newKey === 'startDate'
                                        ? setValue('endDate', '', REVALIDATE_FORM_PROPS)
                                        : setValue('expirationDate', '', REVALIDATE_FORM_PROPS)
                                    const endDate = (newKey === 'startDate') ? 'endDate' : 'expirationDate';
                                    setCalendarOptions((prev: any) => ({
                                        ...prev,
                                        [endDate]: {
                                            ...prev[endDate],
                                            minDate: e.target.value,
                                            disabled: false,
                                        }
                                    }))
                                }
                            };
                        }
                        // func: quicklins, campaigns
                        if (property.key === "status" && property.type === 'boolean') {
                            field.value = getValues("status") === "ACTIVE";
                            field.onChange = (e) => {
                                const newValue =
                                    e.target.value === true ? "ACTIVE" : "INACTIVE";
                                setValue("status", newValue, REVALIDATE_FORM_PROPS);
                            };
                        }
                        // func: products and transactions
                        if (property.key === "type") {
                            field.onChange = (e) => {
                                setValue("type", e.target.value, REVALIDATE_FORM_PROPS);
                                if (e.target.value === "boolean") {
                                    setValue(
                                        "defaultvalue",
                                        false,
                                        REVALIDATE_FORM_PROPS
                                    );
                                }
                                if (e.target.value === "text" || e.target.value === "number") {
                                    setValue("defaultvalue", "", REVALIDATE_FORM_PROPS);
                                }
                            };
                        }
                        if (property.key === "isdefaultforall") {
                            field.onChange = (e) => {
                                setValue(
                                    "isdefaultforall",
                                    e.value,
                                    REVALIDATE_FORM_PROPS
                                );
                                setValue("usagelist", null, REVALIDATE_FORM_PROPS);
                            };
                        }
                        return (
                            property.type === 'dropdown' ?
                                <>
                            
                                    <Dropdown
                                        key={newKey}
                                        id={`input-${newKey}`}
                                        className={`dropdown${(FieldsLinkedTocreateLabelsButton.includes(newKey) && customComponent && !!customComponent) ? " mb-3" : ""}`}
                                        label={t(`${functionality}.${newKey === 'pointServiceType' ? 'typeOfPointAttention' : newKey}Label`)}
                                        placeholder={t(
                                            `${functionality}.${((functionality === 'Products' || functionality === 'Transactions') && properties && newKey === 'type') ? 'proptype' : newKey}PlaceholderLabel`)}
                                        style={{ width: "100%" }}
                                        options={dropdownOptions[newKey]}
                                        filter={!!dropdownFilterObject ? (dropdownFilterObject[newKey] || false) : false}
                                        showClear={!!dropdownShowClearObject ? (dropdownShowClearObject[newKey] || false) : false}
                                        {...field}
                                        readOnly={readOnlyObject ? readOnlyObject[newKey] : false}
                                        disabled={
                                            (disabledFieldsObject && disabledFieldsObject.hasOwnProperty(newKey))
                                                ? disabledFieldsObject[newKey]
                                                : false}
                                        showError={(errors as any)[newKey]?.message ? true : false}
                                        errorMessage={(errors as any)[newKey]?.message}
                                    />
                                    {
                                        FieldsLinkedTocreateLabelsButton.includes(newKey) && customComponent
                                    }
                                </> :
                                property.type === 'textarea' ?
                                    <InputTextarea
                                        id={`input-${newKey}`}
                                        key={newKey}
                                        className={`input-md text-area-scroll${(readOnlyObject && readOnlyObject[newKey]) ? ' text-area-readonly' : ''}`}
                                        label={t(`${functionality}.${newKey}Label`)}
                                        placeholder={t(`${functionality}.${newKey}PlaceholderLabel`)}
                                        autoComplete="off"
                                        style={{ width: "20rem" }}
                                        hasTooltipIcon={property.key === 'linkto' ? true : false}
                                        tooltipIconText={
                                            t(`Quicklinks.linktoTooltipText`)
                                        }
                                        {...field}
                                        {...extraProps}
                                        cols={32}
                                        rows={3}
                                        readOnly={readOnlyObject ? readOnlyObject[newKey] : false}
                                        autoResize
                                        hasError={(errors as any)[newKey]?.message}
                                        errorMessage={(errors as any)[newKey]?.message}
                                    /> :
                                    property.type === 'radioButton' ?
                                        <React.Fragment>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "flex-start",
                                                }}
                                            >
                                                <label
                                                    id={`input-${newKey}`}
                                                    className={`mb-2 block lb `}
                                                >
                                                    {t(`${functionality}.${newKey}Label`)}
                                                </label>
                                            </div>
                                            <div style={{ display: "inline-grid" }}>
                                                {
                                                    radioButtonOptions[newKey].map((radioButtonOption: any) => (
                                                        <RadioButton
                                                            label={t(radioButtonOption.label)}
                                                            {...field}
                                                            value={radioButtonOption.value}
                                                            checked={field.value === radioButtonOption.value}
                                                            disabled={readOnlyObject ? readOnlyObject[newKey] : false}
                                                        />
                                                    ))
                                                }
                                            </div>
                                        </React.Fragment>
                                        :
                                        property.type === 'phone' ?
                                            <PhoneNumberInput
                                                country='co'
                                                localization={language}
                                                label={t(`${functionality}.${newKey}Label`)}
                                                placeholder={t(`${functionality}.${newKey}PlaceholderLabel`)}
                                                searchPlaceholder={t("TableHeader.searchPlacehoder")}
                                                preferredCountries={['co', 'ec']}
                                                {...field}
                                                hasError={(errors as any)[newKey]?.message}
                                                errorMessage={(errors as any)[newKey]?.message}
                                            />
                                            :
                                            property.type === 'calendar' ?
                                                <Calendar
                                                    id={`input-${newKey}`}
                                                    key={newKey}
                                                    className="style-calendar"
                                                    label={t(`${functionality}.${newKey}Label`)}
                                                    isOptional={isOptional[newKey]}
                                                    optionText={t(`${functionality}.optionalLabel`)}
                                                    placeholder={language === 'es' ? "DD/MM/YYYY" : "MM/DD/YYYY"}
                                                    dateFormat={language === 'es' ? "dd/mm/yy" : "mm/dd/yy"}
                                                    locale={language}
                                                    translations={calendarTranslations}
                                                    minDate={(!isDetail && (newKey === 'endDate' || newKey === 'expirationDate') && getValues(startDate))
                                                        ? (getValues(startDate) < new Date()
                                                            ? new Date()
                                                            : getValues(startDate))
                                                        : calendarOptions[newKey]['minDate']
                                                    }
                                                    isDisable={calendarOptions[newKey]['disabled']}
                                                    showTime
                                                    hourFormat="24"
                                                    onShow={() => {
                                                        const timepickerElements = [...document?.getElementsByClassName('p-timepicker')];
                                                        timepickerElements?.map((elem) => elem?.classList?.add('p-disabled'));
                                                    }}
                                                    onMonthChange={() => {
                                                        setTimeout(() => {
                                                            const timepickerElements = [...document?.getElementsByClassName('p-timepicker')];
                                                            timepickerElements?.map((elem) => elem?.classList?.add('p-disabled'));
                                                        }, 100);
                                                    }}
                                                    {...field}
                                                />
                                                :
                                                property.type === 'multiselect' ?
                                                    <div
                                                        style={{
                                                            display: property.key === "usagelist" && isforallValue
                                                                ? 'none'
                                                                : 'flex',
                                                            flexDirection: 'column'
                                                        }}
                                                    >
                                                        <label htmlFor={"usagelist"} className="block lb mt-2 mb-1">
                                                            {t(`${functionality}.${newKey}Label`)}
                                                        </label>
                                                        <MultiSelect
                                                            id={`select-widget`}
                                                            display="chip"
                                                            placeholder={t(`${functionality}.${newKey}PlaceholderLabel`)}
                                                            className="mb-4"
                                                            options={dropdownOptions[newKey]}
                                                            emptyFilterMessage={t("Translations.noAvailableMessage")}
                                                            filter
                                                            {...field}
                                                        />
                                                    </div>
                                                    :
                                                    <CustomInput
                                                        id={`input-${newKey}`}
                                                        key={newKey}
                                                        className={`input-md ${readOnlyObject && readOnlyObject[newKey] ? 'rd-only ibp-readonly' : ''}`}
                                                        label={t(`${functionality}.${newKey}Label`)}
                                                        placeholder={t(`${functionality}.${((functionality === 'Products' || functionality === 'Transactions') && properties && newKey === 'labelkey') ? 'proplabelkey' : newKey}PlaceholderLabel`)}
                                                        type={
                                                            (property.key === "defaultvalue" && typeValue === "boolean")
                                                                ? "boolean"
                                                                : property.type
                                                        }
                                                        autoComplete="off"
                                                        style={{
                                                            width: "20rem",
                                                        }}
                                                        {...field}
                                                        {...extraProps}
                                                        hasError={(errors as any)[newKey]?.message}
                                                        errorMessage={(errors as any)[newKey]?.message}
                                                        disabled={newKey === 'secondaryEmail' && mainEmailValue === '' ? true : false}
                                                        hasTooltip={!!tooltipTextObject && tooltipTextObject.hasOwnProperty(newKey)}
                                                        tooltipText={!!tooltipTextObject && tooltipTextObject.hasOwnProperty(newKey)
                                                            ? tooltipTextObject[newKey] : undefined}
                                                    />
                        );
                    }}
                />
            </div>
        )
    }

    return (
        <BoxFull
            parentClassname="wrapper-form"
            className="flex  py-5 px-5"
            variant="tertiary"
        >
            <div className="flex w-full" style={{ flexDirection: "column" }}>
                {boxTitle &&
                    <p style={{ marginBottom: 'var(--space-m)', lineHeight: '1.5rem' }}>
                        <div dangerouslySetInnerHTML={{ __html: boxTitle }} />
                    </p>
                }
                <div className="form-container md pt-5 pb-2 w-full">
                    <div className="form align-items-center justify-content-center w-full">
                        <div className="flex justify-content-around w-full flex-wrap">
                            <div>
                                {Object.keys(getValues()).length > 0 && (
                                    <>
                                        {fields?.filter((key: any) => key.col === 1).map((property: any) => {
                                            const newKey = property.key.split(".").pop();
                                            return (
                                                RenderForm(newKey, property)
                                            );
                                        })}
                                    </>
                                )}
                            </div>
                            <div>
                                {Object.keys(getValues()).length > 0 && (
                                    <>
                                        {fields?.filter((key: any) => key.col === 2).map((property: any) => {
                                            const newKey = property.key.split(".").pop();
                                            return (
                                                RenderForm(newKey, property)
                                            );
                                        })}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BoxFull>
    );
}